import { DonutChartComponent } from '../charts/donut-chart-component'

export class AFSentiment extends DonutChartComponent {
 static config = {
  selector: 'afSentiment',
  controller: AFSentiment,
  bindings: DonutChartComponent.config.bindings,
  template: DonutChartComponent.config.template,
 }

 setProperties() {
  this.seriesData = this.namingUtils.buildSentimentChartData(this.vizData.data.all)
  this.seriesColors = this.colorUtils.setSentimentColorPalette(this.vizData.data.all)
  this.areDataLabelsVisible = true
 }

 onPointClick = ({ sliceName }) => {
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'sentiment',
    this.namingUtils.getSentimentType(sliceName)
   )
  )
 }
}
